import { StreamWithChatRate } from '../types';
import type { ChatMetrics } from '../services/chatMonitor';

export type TimeWindow = '5s' | '5m';

/**
 * Stamp the monitor's latest reading onto a stream. Returns the very same
 * object when nothing moved, so memoised rows and effects keyed on the
 * stream skip work for the hundred quiet channels on every tick.
 */
export const withMetrics = (
  stream: StreamWithChatRate,
  metric: ChatMetrics | undefined,
  timeWindow: TimeWindow,
): StreamWithChatRate => {
  const chatRate10s = metric?.chatRate10s || 0;
  const chatRate5m = metric?.chatRate5m || 0;
  const chatRate = timeWindow === '5m' ? chatRate5m : chatRate10s;
  const messageCount = metric?.messageCount || 0;
  const sampleSeconds = metric?.sampleSeconds || 0;

  if (
    stream.chatRate === chatRate &&
    stream.messageCount === messageCount &&
    stream.chatRate10s === chatRate10s &&
    stream.chatRate5m === chatRate5m &&
    stream.sampleSeconds === sampleSeconds
  ) {
    return stream;
  }

  return { ...stream, chatRate, messageCount, chatRate10s, chatRate5m, sampleSeconds };
};
